module.exports = __webpack_public_path__ + "media/images/logo-8ed149f905199e74995976b437b185aa.png";